"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSeverityColor = exports.validSeverities = void 0;
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
exports.validSeverities = ['critical', 'high', 'medium', 'low', 'note', 'info'];
/**
 * Returns the color associated with a given severity level.
 * @param severity - The severity level.
 * @param selectedTheme - The selected theme (light or dark).
 * @returns Color associated with the severity level for Text and Icons.
 *   For full color value you need to use `getPrefixedThemeColor`.
 */
var getSeverityColor = function (severity, selectedTheme) {
    switch (severity) {
        case 'critical':
            return (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'red70', dark: 'darkTheme.red100' });
        case 'high':
            return (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'orange70', dark: 'darkTheme.orange' });
        case 'medium':
        case 'low':
        case 'note':
        case 'info':
        default:
            return (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'neutral20', dark: 'darkTheme.prussianBlue' });
    }
};
exports.getSeverityColor = getSeverityColor;
